<template>
    <div class="game__result" v-if="table && table.length">
        <table class="table">
            <thead>
            <tr>
                <th scope="col" class="opacity--md text--center">#</th>
                <th scope="col" class="opacity--md text--left">User</th>
                <th scope="col" class="opacity--md text--center">Wins</th>
                <th scope="col" class="opacity--md text--center">Points</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(row, index) in table" :class="[{'active': row.user.id === currentUser}]">
                <th scope="row">
                    <div class="sequence"><span>{{ index + 1 }}</span></div>
                </th>
                <td>
                    <div class="profile profile--inline profile--horizontal">
                        <figure class="profile__avatar"><span
                            class="profile__avatar__img"><img
                            :src="row.user.avatar" alt=""></span></figure>
                        <div class="profile__text weight--bold">{{ row.user.nick }}</div>
                    </div>
                </td>
                <td class="text--center">{{ row.wins || 0 }}</td>
                <td class="text--center">{{ row.point || 0 }}</td>
            </tr>
            </tbody>
        </table>
    </div>

</template>

<script>
    export default {
        props: ['table', 'currentUser'],
    }
</script>
